var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9797 3.64645C6.17496 3.45118 6.49154 3.45118 6.68681 3.64645L10.6868 7.64645C10.8821 7.84171 10.8821 8.15829 10.6868 8.35355L6.68681 12.3536C6.49154 12.5488 6.17496 12.5488 5.9797 12.3536C5.78444 12.1583 5.78444 11.8417 5.9797 11.6464L9.62614 8L5.9797 4.35355C5.78444 4.15829 5.78444 3.84171 5.9797 3.64645Z",
    fill: "#004CE8",
    stroke: "#004CE8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue);
export default __webpack_public_path__ + "static/media/rightBlue.3a5429bfa160656592de471df8c75cce.svg";
export { ForwardRef as ReactComponent };